<script lang="ts" setup>
import { defineProps } from 'vue';

defineProps<{
  title?: string
  subtitle?: string
  description?: string
  image?: string
}>()
</script>

<template>
    <div
        class="bg-white px-10 px-2.5 py-20 md:px-16.25 lg:px-26.25 lg:py-40 max-w-1440 mx-auto"
        :style="{
            backgroundImage: `url('/assets/sponsorships/left.png'), url('/assets/sponsorships/right.png')`,
            backgroundPosition: 'top left, bottom right',
            backgroundRepeat: 'no-repeat, no-repeat',
            backgroundSize: 'auto, auto'
        }">
            <h2 class="h3-bold md:h2-bold text-center px-3.75">{{ title }}</h2>
            <div class="md:subtitle text-gray-500 mb-[65px] text-center px-3.75">{{ subtitle }}</div>

            <div class="relative h-[330px] msm:h-[440px] md:h-[550px] lg:h-[771px] mx-auto overflow-hidden">
                <div class="absolute top-0 left-0 w-sponsorship h-[300px] msm:h-[410px] md:h-[520px] lg:h-[741px] bg-hantec-primary rounded-2.5"></div>
                <div class="absolute bottom-0 right-0 w-sponsorship h-[300px] msm:h-[410px] md:h-[520px] lg:h-[741px] bg-blue-sponsorship rounded-2.5"></div>
                <div
                    class="relative max-w-sponsorship h-[300px] msm:h-[410px] md:h-[520px] lg:h-[741px] bg-cover bg-center top-[15px] left-[15px] rounded-2.5"
                    :style="{backgroundImage: `url(${image})`}"
                ></div>
            </div>
            <div class="mt-6 px-3.75">{{ description }}</div>
    </div>
</template>

<style lang="sass" scoped></style>
